import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

const [useDeleteJoinLink, deleteJoinLink] = createAsyncAction(
  "spaces/deleteJoinLink",
  async (spaceId: number) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}/join-link`,
      method: "DELETE",
    });
    return { ...res, result: res.result.space };
  }
);

export default useDeleteJoinLink;
export { deleteJoinLink };
